import React from 'react';
import { StyledComponentProps } from '~/types/material-ui';
import { useStyles } from './style';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { EcosystemItemType } from '~/enums/ecosystem.enum';
import clsx from 'clsx';

interface Props extends StyledComponentProps<typeof useStyles> {
  ecosystemType: EcosystemItemType;
}

const EcosystemTypeChip: React.FC<Props> = ({ ecosystemType, classes: propClasses }) => {
  const { classes } = useStyles(undefined, { props: { classes: propClasses } });
  const { t } = useTranslation('common');

  const chipStyles = {
    [EcosystemItemType.WALLET]: {
      chipClass: classes.walletChip,
      textClass: classes.walletChipText,
    },
    [EcosystemItemType.WEB3_BROWSER]: {
      chipClass: classes.web3BrowserChip,
      textClass: classes.web3BrowserChipText,
    },
    [EcosystemItemType.BUSINESS]: {
      chipClass: classes.businessChip,
      textClass: classes.businessChipText,
    },
    [EcosystemItemType.NFT]: {
      chipClass: classes.nftChip,
      textClass: classes.nftChipText,
    },
    [EcosystemItemType.EXCHANGE]: {
      chipClass: classes.exchangeChip,
      textClass: classes.exchangeChipText,
    },
    [EcosystemItemType.DEVTOOL]: {
      chipClass: classes.devtoolChip,
      textClass: classes.devtoolChipText,
    },
    [EcosystemItemType.STABLE_COIN]: {
      chipClass: classes.stableCoinChip,
      textClass: classes.stableCoinChipText,
    },
    [EcosystemItemType.VALIDATOR]: {
      chipClass: classes.validatorChip,
      textClass: classes.validatorChipText,
    },
  };

  const { chipClass, textClass } =
    chipStyles[ecosystemType] || chipStyles[EcosystemItemType.VALIDATOR];

  return (
    <div className={clsx(classes.chip, chipClass)}>
      <Typography className={clsx(classes.chipText, textClass)}>
        {t(`ecosystem_page.${ecosystemType}`)}
      </Typography>
    </div>
  );
};

export default EcosystemTypeChip;
